import * as React from 'react';

import {gameControlComponent, GameControlComponentConfigurationContext} from './gameControlComponentConfiguration';

const withGameControlComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameControlComponentConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameControlComponent}/>
                );
            }}
        </GameControlComponentConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameControlComponentConfiguration;